import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { ApplicantInterviews } from '@app/models/recruiting/applicant-interviews.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { EvaluationColumn } from './columns/evaluation.column';
import { InterviewerColumn } from './columns/interviewer.column';
import { SubmittedColumn } from './columns/submitted.column';

@Injectable()
export class ApplicantInterviewersSummaryTable extends Table {
    static openOption: MenuColumnItem = {
        label: 'open',
        event: 'open',
    };

    showMenuColumnOptions = true;
    links = false;

    constructor(
        protected auth: AuthService,
        private applicantInterview: ApplicantInterviews
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.addColumns(new InterviewerColumn(), new SubmittedColumn(), new EvaluationColumn());
    }

    getMenuColumnOptionsForRow(applicantInterviewer: ApplicantInterviewers): MenuColumnItem[] {
        if (!applicantInterviewer?.interviewer) {
            return [];
        }

        return this.auth.employee.id === applicantInterviewer.interviewer.id && !applicantInterviewer.isSubmitted
            ? [ApplicantInterviewersSummaryTable.openOption]
            : [];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            ApplicantInterviewers.where('atsApplicantInterviewId', this.applicantInterview.id).with([
                'interviewer',
                'applicantInterview',
            ])
        );
    }
}
